const style = {
  bottombar: {
    position: "absolute",
    bottom: 60,
    right: 5,
    zIndex: 1000,

    liDisabled: {
      backgroundColor: "lightgrey",
    },

    liHide: {
      display: "none",
    },

    li: {
      listStyleType: "none",
      marginRight: 10,
      paddingTop: 4,
      width: 45,
      height: 40,
      backgroundColor: "rgba(255,255,255, 0.7)",
      borderRadius: 4,
      padding: 1,
      textAlign: "center",
      border: "solid 1px white",
      icon: {
        fontSize: 30,
        marginTop: 3,
      },
    },
  },
};

export const bottombarCSS = style.bottombar;
